"use client";

import type { FC, Ref } from "react";
import { AnalysisGallery, type AnalysisGalleryProps } from "@huub-web/shared";

export interface AnalysisGalleryTemplateProps {
  images: AnalysisGalleryProps["images"];
}

/**
 * @deprecated
 */
export const AnalysisGalleryTemplate: FC<
  AnalysisGalleryTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ images, ref }) => (
  <AnalysisGallery ref={ref} images={images} container="default" />
);
